// MpfWarningCallout.props.ts
// NHS DS: https://service-manual.nhs.uk/design-system/components/warning-callout
import type { HeadingLevel } from '../MpfInput/MpfInputBaseProps';

export interface MpfWarningCalloutProps {
  heading: string;
  headingLevel?: HeadingLevel;
  srPrefix?: string;
  marginClass?: string;
}

export const mpfWarningCalloutDefaults = {
  headingLevel: 3,
  srPrefix: 'Important',
} satisfies Partial<MpfWarningCalloutProps>;
